var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.643,
    height: 38.657,
    viewBox: "0 0 38.643 38.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fc6c1c;}.b{fill:#c7ccd9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.293,
    height: 2.576,
    rx: 1.288,
    transform: "translate(16.485 32.383)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.293,
    height: 2.576,
    rx: 1.288,
    transform: "translate(16.485 27.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.293,
    height: 2.576,
    rx: 1.288,
    transform: "translate(9.56 32.383)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.293,
    height: 2.576,
    rx: 1.288,
    transform: "translate(9.56 27.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.293,
    height: 2.576,
    rx: 1.288,
    transform: "translate(16.485 22.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.589,37.623a9.69,9.69,0,0,0-4.4-7.131V16.273a3.117,3.117,0,0,0-3.113-3.113H34.092v3.366a4.079,4.079,0,1,1-8.157,0V13.16H18.249v3.366a4.079,4.079,0,1,1-8.157,0V13.16H8.113A3.117,3.117,0,0,0,5,16.273V40.745a3.117,3.117,0,0,0,3.113,3.113H25.831a9.669,9.669,0,0,0,17.757-6.234Zm-9.617,8.741a7.728,7.728,0,0,1-7.5-5.8.992.992,0,0,0-1.073-.738.966.966,0,0,0-.807,1.194c.082.3.176.6.279.893H8.121a1.181,1.181,0,0,1-1.189-1.185V25h30.32v4.538a9.527,9.527,0,0,0-2.035-.5,9.651,9.651,0,0,0-8.046,2.718V29.3a.966.966,0,1,0-1.932,0v6.376h6.38a.966.966,0,1,0,0-1.932H27.974a7.728,7.728,0,1,1,6.011,12.622Z",
    transform: "translate(0 -4.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.544,67.638l2.147-2.147a.859.859,0,1,0-1.211-1.215l-2.765,2.765a.859.859,0,0,0,0,1.215l4.272,4.238A.859.859,0,1,0,76.2,71.279Z",
    transform: "translate(-37.358 -33.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.407,14.016a2.147,2.147,0,0,0,2.147-2.147V7.147a2.147,2.147,0,1,0-4.293,0v4.723a2.147,2.147,0,0,0,2.147,2.147Z",
    transform: "translate(-30.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.507,14.016a2.147,2.147,0,0,0,2.147-2.147V7.147a2.147,2.147,0,0,0-4.293,0v4.723a2.147,2.147,0,0,0,2.147,2.147Z",
    transform: "translate(-9.336)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHistory);
export default __webpack_public_path__ + "static/media/event_history.d6f68ac58fb0c50ec163a5be4a9f62d6.svg";
export { ForwardRef as ReactComponent };